import {format} from "date-fns";
import React, {useState} from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApiConnect from "../../../../Utils/ApiConnect";

export default function Deductions() {
  const [reportList, setreportList] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [filterText, setFilterText] = useState("");
  const fetchReport = () => {
    ApiConnect.get(
      `/Module/Inventory/Stock/DeductionReport?form=${format(
        startDate,
        "yyyy-MM-dd"
      )}&to=${format(endDate, "yyyy-MM-dd")}`
    )
      .then((response) => {
        setreportList(response.data);
      })
      .catch((error) => console.log(error));
  };
  const columns = [
    {
      name: "Date",
      selector: row => row.date,
      sortable: true,
    },
    {
      name: "Employee",
      selector: row => row.employee,
      sortable: true,
    },
    {
      name: "Product",
      selector: row => row.product,
      width: "300px",
      sortable: true,
    },
    {
      name: "Qty",
      selector: row => row.qty,
      sortable: true,
    },
    {
      name: "Damage",
      selector: row => row.damage,
      sortable: true,
    },
    {
      name: "Remark",
      selector: row => row.remark,
      sortable: true,
    },
    {
      name: "User",
      selector: row => row.user,
      className: "table-actions",
      width: "150px",
      sortable: false,
      cell: (row) => {
        return (
          <React.Fragment>
            <img
              className="avatar avatar-sm"
              src={row.user.avatar}
              alt={row.user.name}
            />
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = reportList.filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <header className="header no-border">
          <div className="header-info mb-0">
            <div className="left">
              <h2 className="header-title">
                <strong>Stock Deductions</strong>
              </h2>
            </div>
            <div className="right row">
              <div className="input-group col">
                <label htmlFor="start">From Date</label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  closeOnScroll={true}
                  selected={startDate}
                  value={startDate}
                  onChange={(e) => setStartDate(e)}
                  placeholderText="Start Date"
                />
              </div>
              <div className="input-group col">
                <label htmlFor="start">To Date</label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  closeOnScroll={true}
                  selected={endDate}
                  value={endDate}
                  onChange={(e) => setEndDate(e)}
                  placeholderText="End Date"
                />
              </div>
              <button
                className="btn btn-primary col-2 btn-sm"
                onClick={() => fetchReport()}
              >
                Fetch
              </button>
            </div>
          </div>
          <div className="header-action"></div>
        </header>
        <div className="card-body">
          <div className="dataTables_wrapper">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={e => setFilterText(e.target.value)}
              />
            </div>
            <DataTable
              className="table table-separated"
              keyField="id"
              columns={columns}
              data={filteredData}
              pagination
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
              paginationPerPage={10}
              customStyles={customStyles}
              filter
              exportable
            />
          </div>
        </div>
      </div>
    </div>
  );
}
